import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS, LabelL } from '@sorare/core/src/atoms/typography';
import { ANY_SPORT_SCOUTING_CENTER } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

const Root = styled(Vertical)`
  padding: calc(var(--unit) * 7);
  border: 1px dashed var(--c-nd-150);
  border-radius: var(--double-unit);
`;

export const WatchlistEmptyState = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <FullWidthContainer>
      <Root gap={1.5} center>
        <Vertical className="text-center" center gap={0.5}>
          <FontAwesomeIcon icon={faUsers} size="lg" />
          <HeadlineS>
            <FormattedMessage defaultMessage="Nothing here yet" />
          </HeadlineS>
          <LabelL color="var(--c-nd-600)">
            <FormattedMessage defaultMessage="This watchlist is empty for now" />
          </LabelL>
        </Vertical>
        <Horizontal center>
          <Button
            size="medium"
            color="tertiary"
            to={generateSportContextPath(ANY_SPORT_SCOUTING_CENTER)}
          >
            <FormattedMessage {...scoutingCenter.scoutNow} />
          </Button>
        </Horizontal>
      </Root>
    </FullWidthContainer>
  );
};
